




















































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import TelaGenerica from '@/components/layout/TelaGenerica.vue'
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue'
import SeletorDeFamiliaDoProduto from '@/components/produto/SeletorDeFamiliaDoProduto.vue'
import DialogoDeEdicaoDeFamiliaDoProduto from '@/components/produto/DialogoDeEdicaoDeFamiliaDoProduto.vue'
import { Page, FamiliaDoProduto } from '@/models'
import { CancelToken } from 'axios'
import { Pageable } from '@/models/Pageable'
import { SaveFamiliaDoProdutoUseCase } from '@/usecases/produto/tipoProduto'

@Component({
	components: {
		TelaGenerica,
		DialogoDeEdicaoDeFamiliaDoProduto,
		DataTableDeCrudPaginado,
		SeletorDeFamiliaDoProduto,
	},
})

export default class TelaDeFamiliasDoProduto extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicao!: DialogoDeEdicaoDeFamiliaDoProduto
	
	familias: FamiliaDoProduto[] = []
	busca = ''
	carregando = false
	editando = false
	familia: FamiliaDoProduto | null = null

	saveFamiliaDoProdutoUseCase = new SaveFamiliaDoProdutoUseCase()
	
	headers = [
		{ text: 'Familia', value: 'nome' },
	]

	abrirDialogoDeEditarFamilia (indice: number) {
		this.editando = true
		this.familia = this.familias[indice]
		
		this.dialogoDeEdicao.mostrar()
	}

	abrirDialogoDeCriarFamilia() {
		this.editando = false
		this.familia = {id:"",nome:""}

		this.dialogoDeEdicao.mostrar()
	}

	async buscarPagina(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<FamiliaDoProduto>> {
		const pagina = await this.saveFamiliaDoProdutoUseCase.listarFamiliasDoProduto({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.familias = pagina.content
		return pagina
	}

	familiaSalva(familiaSalva) {
		const indice = this.familias.findIndex(familia => familia.id === familiaSalva.id)

		if (indice === -1) {
			this.familias.push(familiaSalva)
		} else {
			this.familias.splice(indice, 1, familiaSalva)
		}
	}

	@Watch('busca')
	novaBusca() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}
}
